export const calculateHealthPercentage = (params: { currentHealth: number; maxHealth: number }) => {
   const { currentHealth, maxHealth } = params;

   const percentage = Math.round((currentHealth / maxHealth) * 100);
   if (percentage < 0) {
      return 0;
   }

   return percentage;
};
